//Import required libraries
import React, { useEffect, useState } from 'react';
import * as d3 from 'd3';

//Import Styles
import './VizAnalysis.scss';

//Import Data
import { getDocsInfo } from '../../../../utils/utils'

//Import Utils
import { makePieChart, makeYearBar, makeCategoryBar } from './VizFunctions'

const VizAnalysis = props => {

    let { docs, filter, setFilter } = props
    const [docsInfo, setDocsInfo] = useState(null);
    // console.log('DOCS', docs);
    // console.log('DOCS INFO', docsInfo);

    useEffect(() => {
        let docsInfo = getDocsInfo(docs);
        docsInfo['showHideDist'] = {
            show: docsInfo.totalShow,
            hide: docsInfo.totalHide,
        }
        // console.log('DOCS INFO', docsInfo);
        setDocsInfo(docsInfo);
    }, [docs])

    //Populate charts
    useEffect(() => {
            // console.log('I RANNNNNNNN');
            // console.log('DOCS INFO inside useEffect', docsInfo);
            if (docsInfo) {
                makePieChart(docsInfo.showHideDist, filter, setFilter)
                makeYearBar(docsInfo.yearArr, filter, setFilter);
                makeCategoryBar(docsInfo.catArr, filter, setFilter);
            }
    }, [docsInfo])

    return (
        <div className='admin-viz-analysis'>
            {
                docsInfo &&
                <>
                    <div className='viz-container'>
                        <h3 className='viz-title'>Total Photos</h3>
                        <p className='viz-subtitle'>Click to filter</p>
                        <div id='total-pie-container'></div>
                        <h3 className='total'>{`${docsInfo.total} uploaded `}</h3>
                        <p className='show'>{`${docsInfo.totalShow} showing (${d3.format(",.0%")(docsInfo.totalShow/docsInfo.total)})`}</p>
                        <p className='hide'>{`${docsInfo.totalHide} hidden (${d3.format(",.0%")(docsInfo.totalHide/docsInfo.total)})`}</p>
                    </div>
                    <div className='viz-container'>
                        <h3 className='viz-title'>Year-wise Split</h3>
                        <p className='viz-subtitle'>Click to filter</p>
                        <div id='year-bar-container'></div>
                    </div>
                    <div className='viz-container'>
                        <h3 className='viz-title'>Category-wise Split</h3>
                        <p className='viz-subtitle'>Click to filter</p>
                        <div id='category-bar-container'></div>
                    </div>
                </>
            }
        </div>
    )
}

export default VizAnalysis